export { default } from './AttestationsCard';
